/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { EmbeddedTelemetryViewer } from '@/components/EmbeddedTelemetryViewer/EmbeddedTelemetryViewer';

export function BIDashboardPage() {
  return <EmbeddedTelemetryViewer path="/bi-dashboard" iframeTitle="BI Dashboard" />;
}
